var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("custom-tooltip-container", {
        scopedSlots: _vm._u([
          {
            key: "tooltipTarget",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass: "ob1-link-icon ps-1",
                    attrs: { "data-testid": "cart-recovery-tooltip-target" },
                  },
                  [
                    _c("span", {
                      staticClass: "icon icon-buy",
                      staticStyle: { "font-size": "40px" },
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _vm.badgeValue > 0 && _vm.emptyCart == false
                      ? _c("span", {
                          staticClass:
                            "ob1-badge ob1-badge-negative ob1-badge-large",
                          staticStyle: {
                            "margin-left": "-10px",
                            "margin-top": "-40px",
                          },
                          domProps: { textContent: _vm._s(_vm.badgeValue) },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "visually-hidden" }, [
                      _vm._v("articles dans votre panier"),
                    ]),
                  ]
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tooltipContent",
            fn: function () {
              return [
                _c(
                  "div",
                  { attrs: { "data-testid": "cart-recovery-tooltip-content" } },
                  [
                    _c(
                      "div",
                      { staticClass: "d-flex flex-column p-1" },
                      [
                        _c("strong", {
                          staticClass: "mb-2 font-size-16",
                          domProps: { textContent: _vm._s(_vm.title) },
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.content, function (item, idx) {
                          return _c(
                            "span",
                            {
                              key: idx,
                              staticClass: "mb-1 d-block truncate-multiline",
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(item) +
                                  "\n                    "
                              ),
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm.ctaLabel
                          ? _c(
                              "div",
                              { staticClass: "text-center" },
                              [
                                _c("ob1-boutons", {
                                  staticClass: "px-1 px-md-2 mt-1 mt-lg-0",
                                  attrs: {
                                    "is-button": false,
                                    "is-primary": true,
                                    label: _vm.ctaLabel,
                                    href: _vm.ctaUrl,
                                    "data-oevent-category": "reprise_panier",
                                    "data-oevent-action": _vm.ctaLabel,
                                    "data-oevent-label": _vm.content,
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }